import type { AxiosRequestConfig } from 'axios';

import { axiosInstance } from '../axios-instance';

type RequestOptions = AxiosRequestConfig | undefined;

export interface OperatorPermissionsWireDto {
  featureKeys?: string[];
  toolRoleName?: string | null;
  isReadOnlyOperator?: boolean;
  allDatabases?: boolean;
  databaseNames?: string[];
  scopeLabel?: string;
  /** PascalCase wire variant from some BE serializers. */
  IsReadOnlyOperator?: boolean;
}

/**
 * Omitted from published OpenAPI until TROC-197 ships; see `orval.config.ts`.
 * Path matches gateway-prefixed User Management v1 routes (`/api/user-management/v1/...`).
 */
export const getApiUserManagementV1OperatorPermissions = (options?: RequestOptions, signal?: AbortSignal) => {
  return axiosInstance<OperatorPermissionsWireDto>(
    { url: '/api/user-management/v1/operator-permissions', method: 'GET', signal },
    options
  );
};
